import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { isAdminRole } from '../utils/admin-role';

export const adminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (isAdminRole(auth.currentUser()?.role)) {
    return true;
  }
  return router.createUrlTree(['/wishlists']);
};
